export const YOGA_TEACHER_TRAINING = "Yoga Teacher Training";
export const ONLINE_COURSE = "Online Course";
export const PRENATAL_YOGA = "Prenatal Yoga";
export const DEDICATED_PAGE_TYPES = [YOGA_TEACHER_TRAINING, ONLINE_COURSE, PRENATAL_YOGA];

export const FEATURED_COURSE_LINKS = [
  { label: "Prenatal Yoga Training", path: "/prenatal-yoga", icon: "Heart" },
  { label: "Yoga Teacher Training", path: "/yoga-teacher-training", icon: "GraduationCap" },
  { label: "Online Yoga Courses", path: "/online-courses", icon: "Monitor" },
];
